import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type CreateSiteApiResponse } from '../services/createSiteService'

export interface CreateSiteState {
  isLoading: boolean
  error: string | undefined
  data: CreateSiteApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: CreateSiteState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const createSiteSlice = createSlice({
  name: 'CreateSiteSlice',
  initialState,
  reducers: {
    createSiteLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    createSiteUpdateAction: (state, action: PayloadAction<{ data: CreateSiteApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    createSiteErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  createSiteLoadingAction,
  createSiteUpdateAction,
  createSiteErrorAction,
  reset
} = createSiteSlice.actions

export default createSiteSlice.reducer
